<template>
    <v-container fluid fill-height px-0 class="main-container d-block">
        <div class="content-block">
            <HeaderMenu :title="title" class="mx-6 mb-6" back-page/>
            <v-layout class="remote-control" column>
                <v-flex xs12 row justify-center line-buttons v-if="device">
                    <div class="bold-text text-center d-inline-flex">
                        {{device.name}}
                        <span v-if="device.location" class="main-text d-inline-flex text-lowercase">, {{device.location}}</span>
                    </div>
                </v-flex>
                <div class="subtitle-text text-center mb-3" v-if="device && device.state">
                    <span class="mr-2" v-if="device.state.temperature">Температура: {{ (device.state.temperature).toFixed(1) }}°C;</span>
                    <span v-if="device.state.humidity">Влажность: {{ (device.state.humidity).toFixed(1) }}%</span>
                </div>
                <v-flex xs12 d-inline-flex justify-center align-center line-buttons>
                    <v-btn class="btn-light-grey mr-3" :class="{'btn-light-grey__active': week}" @click="week = true">
                        Неделя
                    </v-btn>
                    <v-btn class="btn-light-grey ml-3" :class="{'btn-light-grey__active': !week}" @click="week = false">
                        День
                    </v-btn>
                </v-flex>
                <v-flex xs12 d-inline-flex justify-center align-center line-buttons v-if="!week">
                    <div @click="increaseDay" class="date-arrow left" :class="{'date-arrow__disabled': day == daysUniq.length - 1}">
                        <ArrowRightIcon/>
                    </div>
                    <div>{{daysUniq[day] | formatDate }}</div>
                    <div @click="reduceDay" class="date-arrow right" :class="{'date-arrow__disabled': day == 0}">
                        <ArrowRightIcon/>
                    </div>
                </v-flex>
                <div class="common-text text-center px-2">
                    <div class="mt-2" v-if="device && device.device_type == 7">
                        Температура, °C
                    </div>
                    <div class="wrapper mb-5" v-if="device && device.device_type == 7">
                        <VueApexCharts width="100%" type="area" :options="chartTemperaturesOptions" :series="temperatures"></VueApexCharts>
                    </div>
                    <div class="mt-5" v-if="device && device.device_type == 18">
                        Влажность, %
                    </div>
                    <div class="wrapper mb-3" v-if="device && device.device_type == 18">
                        <VueApexCharts width="100%" type="area" :options="chartHumiditiesOptions" :series="humidities"></VueApexCharts>
                    </div>
                </div>
            </v-layout>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных" noCancel></ModalWaiting>
    </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import HeaderMenu from "@/components/core/HeaderMenu";
import ArrowRightIcon from "@/assets/icons/ArrowRightIcon";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";

export default {
    name: "ChartPage",
    components: {HeaderMenu, ArrowRightIcon, ModalWaiting, VueApexCharts},
    data() {
        return {
            deviceUID: null,
            deviceType: null,
            actions: [],
            week: false,
            day: null,
            daysUniq: [],
            device: null,
            chartTemperaturesOptions: {
                chart: {
                    events: {
                        click: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                        mouseMove: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                    },
                    height: 350,
                    toolbar: {
                        show: false,
                    },
                    type: "area",
                    zoom: {
                        enabled: false,
                    },
                },
                colors: ["#FFBAB8"],
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    type: "gradient",
                    colors: ['#FFBAB8', '#fecdcb', '#fff7d0', '#FFFFFF'],
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.7,
                        opacityTo: 0.9,
                        stops: [0, 90, 100]
                    }
                },
                plotOptions: {
                    area: {
                        fillTo: "end",
                    }
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: false,
                    },
                    y: {
                        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
                            let time = w.config.series[seriesIndex].data[dataPointIndex].x.split(" ");
                            if (this.week) {
                                const [year, month, day] = time[0].split("-");
                                time = day + "." + month + " в " + time[1].slice(0, 5);
                            } else {
                                time = "в " + time[1].slice(0, 5);
                            }
                            return val ? val.toFixed(1) + "°C " + time : "";
                        },
                        title: {
                            show: false,
                        },
                    },
                    marker: {
                        show: false,
                    },
                },
                xaxis: {
                    type: "category",
                    labels: {
                        formatter: (val) => {
                            return this.getLabel(val);
                        }
                    },
                    tickAmount: 9,
                    tickPlacement: "on",
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val ? val.toFixed(1) + "°C" : "";
                        },
                    },
                },
            },
            chartHumiditiesOptions: {
                chart: {
                    events: {
                        click: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                        mouseMove: function(event, chartContext, config) {
                            let tooltip = chartContext.el.querySelector('.apexcharts-tooltip');
                            let pointsArray = config.globals.pointsArray;
                            let seriesIndex = config.seriesIndex;
                            let dataPointIndex = config.dataPointIndex === -1 ? 0 : config.dataPointIndex;

                            if (seriesIndex !== -1) {
                                let position = pointsArray[seriesIndex][dataPointIndex];

                                tooltip.style.top = position[1] + 'px';
                                tooltip.style.left = position[0] + 'px';
                            }
                        },
                    },
                    height: 350,
                    toolbar: {
                        show: false,
                    },
                    type: "area",
                    zoom: {
                        enabled: false,
                    },
                },
                colors: ["#FFF4BC"],
                dataLabels: {
                    enabled: false,
                },
                fill: {
                    type: "gradient",
                    colors: ["#FFF4BC", "#fff7d0", "#fecdcb", "#FFFFFF"],
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.7,
                        opacityTo: 0.9,
                        stops: [0, 90, 100]
                    }
                },
                plotOptions: {
                    area: {
                        fillTo: "end",
                    }
                },
                tooltip: {
                    enabled: true,
                    x: {
                        show: false,
                    },
                    y: {
                        formatter: (val, { seriesIndex, dataPointIndex, w }) => {
                            let time = w.config.series[seriesIndex].data[dataPointIndex].x.split(" ");
                            if (this.week) {
                                const [year, month, day] = time[0].split("-");
                                time = day + "." + month + " в " + time[1].slice(0, 5);
                            } else {
                                time = "в " + time[1].slice(0, 5);
                            }
                            return val ? val.toFixed(1) + "% " + time : "";
                        },
                        title: {
                            show: false,
                        },
                    },
                    marker: {
                        show: false,
                    },
                },
                xaxis: {
                    type: "category",
                    labels: {
                        formatter: (val) => {
                            return this.getLabel(val);
                        }
                    },
                    tickAmount: 9,
                    tickPlacement: "on",
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val ? val.toFixed(1) + "%" : "";
                        },
                    },
                },
            },
        };
    },
    filters: {
        formatDate(val) {
            if (!val) {
                return null;
            }
            let [year, month, day] = val.split("-");
            return day + "." + month + "." + year;
        },
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    computed: {
        title() {
            if (this.device && this.device.device_type == 7) {
                return "Температура";
            }
            if (this.device && this.device.device_type == 18) {
                return "Влажность";
            }
            return "Температура и влажность";
        },
        temperatures() {
            if (this.actions) {
                let data = this.actions;
                let temp = [];
                if (!this.week) {
                    data = JSON.parse(JSON.stringify(this.actions)).filter((el) => {
                        return el.date.split(" ")[0] == this.daysUniq[this.day]
                    });
                    data.forEach((el) => {
                        let obj = {y: el.state.temperature};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                    if (this.day == 0) {
                        let i = temp[0] ? this.getLabel(temp[0].x) : -1;
                        for (i = parseInt(i) + 1; i < 24; i++) {
                            let hour = String(i).padStart(2, "0");
                            let exist = temp.find((el) => (el.x).split(" ")[1].slice(0, 2) === hour );
                            if (exist === undefined) {
                                temp.unshift({
                                    y: null,
                                    x: ` ${hour}:00`
                                });
                            }
                        }
                    }
                }
                else {
                    data.forEach((el) => {
                        let obj = {y: el.state.temperature};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                }
                temp.reverse();
                return [ { name: "Температура", data: temp } ];
            }
            return [ { name: "Температура", data: [] } ];
        },
        humidities() {
            if (this.actions) {
                let data = this.actions;
                let temp = [];
                if (!this.week) {
                    data = JSON.parse(JSON.stringify(this.actions)).filter((el) => {
                        return el.date.split(" ")[0] == this.daysUniq[this.day]
                    });
                    data.forEach((el) => {
                        let obj = {y: el.state.humidity};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                    if (this.day == 0) {
                        let i = temp[0] ? this.getLabel(temp[0].x) : -1;
                        for (i = parseInt(i) + 1; i < 24; i++) {
                            let hour = String(i).padStart(2, "0");
                            let exist = temp.find((el) => (el.x).split(" ")[1].slice(0, 2) === hour );
                            if (exist === undefined) {
                                temp.unshift({
                                    y: null,
                                    x: ` ${hour}:00`
                                });
                            }
                        }
                    }
                }
                else {
                    data.forEach((el) => {
                        let obj = {y: el.state.humidity};
                        obj.x = el.date;
                        temp.push(obj);
                    });
                }
                temp.reverse();
                return [ { name: "Влажность", data: temp } ];
            }
            return [ { name: "Влажность", data: [] } ];
        },
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.query.device;
            this.deviceType = this.$route.query.type;
            if (this.deviceUID) {
                this.getData();
            }
        },
        getData() {
            this.$refs.modalWaiting.open();
            let url = "";
            if (this.deviceType == "temp") {
                url = "/devices/guest/temperature-history/";
            }
            if (this.deviceType == "hum") {
                url = "/devices/guest/humidity-history/";
            }
            this.$http.get(url + this.deviceUID + '/')
                .then((res) => {
                    this.actions = res.data.actions;
                    this.device = res.data.device;
                    this.actions.forEach((el) => {
                        let date = el.date.split(" ")[0];
                        if (!this.daysUniq.includes(date)) {
                            this.daysUniq.push(date);
                        }
                    });
                    this.day = 0;
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        reduceDay() {
            if (this.day > 0) {
                this.day--;
            }
        },
        increaseDay() {
            if (this.day < this.daysUniq.length - 1) {
                this.day++;
            }
        },
        getLabel(val) {
            if (val) {
                if (!this.week) {
                    return String(parseInt((val).split(" ")[1].slice(0, 5).split(":")[0])).padStart(2, "0");
                }
                let dateLabel = val.split(" ")[0].split("-");
                return dateLabel[2] + "." + dateLabel[1];
            }
            return "";
        },
    },
}
</script>

<style lang="scss">
.main-container.container-fixed .remote-control {
    height: calc(100% - 54px);
    justify-content: flex-start;
}

.btn-light-grey {
    display: flex;
    padding: 12px 24px;
    background: rgba(247, 247, 249, 0.38);
    box-shadow: 0 4px 15px rgba(37, 37, 37, 0.1);
    border-radius: 30px;
    justify-content: space-between;
    max-height: 72px;
    align-items: center;

    &__active {
        background: linear-gradient(180deg, rgba(255, 244, 188, 0.8) 0%, rgba(255, 132, 132, 0.432) 100%);
    }
}

.date-arrow {
    float: left;
    width: 28px;
    height: 28px;
    line-height: 32px;
    text-align: center;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &.left {
        transform: rotate(180deg);
        padding-left: 15px;
    }

    &.right {
        padding-left: 15px;
    }

    svg {
        stroke: #130F26;
    }

    &__disabled {
        svg {
            stroke: rgba(0,0,0,.3);
        }
    }
}

.wrapper {
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    max-height: 700px;
    display: block;
}

.line-buttons {
    min-height: 50px;
    max-height: 50px;
    height: 50px;
}
</style>